import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "pm_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

// Attach bearer token to every request when present
axios.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

// ---- Public ----
export const createBooking = async (payload) => {
  const { data } = await axios.post(`${API}/bookings`, payload);
  return data;
};

export const createCallback = async (payload) => {
  const { data } = await axios.post(`${API}/callbacks`, payload);
  return data;
};

export const getAvailability = async (date, office) => {
  const params = office ? { date, office } : { date };
  const { data } = await axios.get(`${API}/availability`, { params });
  return data;
};

// ---- Auth ----
export const apiLogin = async (username, password) => {
  const { data } = await axios.post(`${API}/auth/login`, { username, password });
  return data;
};

export const apiMe = async () => {
  const { data } = await axios.get(`${API}/auth/me`);
  return data;
};

export const apiChangeCredentials = async (payload) => {
  const { data } = await axios.post(`${API}/auth/change-credentials`, payload);
  return data;
};

// ---- Admin (protected) ----
export const getBookings = async () => {
  const { data } = await axios.get(`${API}/bookings`);
  return data;
};

export const getCallbacks = async () => {
  const { data } = await axios.get(`${API}/callbacks`);
  return data;
};

export const getTemplates = async () => {
  const { data } = await axios.get(`${API}/admin/templates`);
  return data;
};

export const updateTemplate = async (key, payload) => {
  const { data } = await axios.put(`${API}/admin/templates/${key}`, payload);
  return data;
};

export const sendFollowup = async (payload) => {
  const { data } = await axios.post(`${API}/admin/send-followup`, payload);
  return data;
};

export const confirmBooking = async (recordId) => {
  const { data } = await axios.post(`${API}/admin/confirm-booking`, { record_id: recordId });
  return data;
};

export const deleteBooking = async (bookingId) => {
  const { data } = await axios.delete(`${API}/bookings/${bookingId}`);
  return data;
};

export const formatApiError = (e) => {
  const detail = e?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d?.msg || JSON.stringify(d)).join(" ");
  return e?.message || "Ismeretlen hiba történt.";
};
